var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.043 20.0279L18.8293 8.66544C19.3069 8.0527 19.4767 7.3443 19.3175 6.62299C19.1795 5.96726 18.7763 5.34377 18.1714 4.87078L16.6964 3.69906C15.4124 2.67784 13.8207 2.78534 12.9081 3.95706L11.9212 5.23735C11.7939 5.39752 11.8257 5.63401 11.9849 5.76301C11.9849 5.76301 14.4786 7.76246 14.5317 7.80546C14.7014 7.96671 14.8288 8.1817 14.8606 8.43969C14.9137 8.94493 14.5635 9.41792 14.0435 9.48242C13.7995 9.51467 13.566 9.43942 13.3962 9.29967L10.7752 7.21422C10.6478 7.11855 10.4568 7.13898 10.3507 7.26797L4.1217 15.3303C3.71846 15.8355 3.58051 16.4912 3.71846 17.1255L4.51433 20.5761C4.55678 20.7589 4.71595 20.8879 4.90696 20.8879L8.40878 20.8449C9.04547 20.8341 9.63972 20.5439 10.043 20.0279ZM14.9463 18.9533H20.6563C21.2134 18.9533 21.6666 19.4123 21.6666 19.9766C21.6666 20.5421 21.2134 21 20.6563 21H14.9463C14.3891 21 13.936 20.5421 13.936 19.9766C13.936 19.4123 14.3891 18.9533 14.9463 18.9533Z",
    fill: "#0050AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBold);
export default __webpack_public_path__ + "static/media/edit-bold.c1507862a39b254dfd5e72702c1a0751.svg";
export { ForwardRef as ReactComponent };